import {
  PublicClientApplication,
  type AuthenticationResult,
  type Configuration,
  type RedirectRequest,
} from '@azure/msal-browser';

const tenantId = import.meta.env.VITE_AZURE_TENANT_ID as string;
const clientId = import.meta.env.VITE_AZURE_CLIENT_ID as string;
const redirectUri = (import.meta.env.VITE_AZURE_REDIRECT_URI as string) || window.location.origin;

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
};

export const loginRequest: RedirectRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
  prompt: 'login',
};

export const msalInstance = new PublicClientApplication(msalConfig);

let initializePromise: Promise<void> | null = null;
let redirectResponsePromise: Promise<AuthenticationResult | null> | null = null;

export function ensureMsalInitialized(): Promise<void> {
  if (!initializePromise) {
    initializePromise = msalInstance.initialize();
  }
  return initializePromise;
}

// Memoized: must be called once at app bootstrap (before React Router mounts)
// so MSAL can read the auth code from the URL before anything rewrites it.
// Subsequent callers get the same cached result.
export function getRedirectResponse(): Promise<AuthenticationResult | null> {
  if (!redirectResponsePromise) {
    redirectResponsePromise = ensureMsalInitialized().then(() =>
      msalInstance.handleRedirectPromise()
    );
  }
  return redirectResponsePromise;
}
